var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Impact_Blue",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B1128;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,19.6c-0.8-0.9-1.2-2.1-1.1-3.4c0.2-3.2-2-6.2-5.1-7.1c-1.2-0.3-2.2-1.1-2.9-2.1 c-1.8-2.7-5.3-3.9-8.3-2.7c-1.1,0.4-2.4,0.4-3.5,0c-3-1.2-6.5,0-8.3,2.7c-0.7,1-1.7,1.8-2.9,2.1C8,10.1,5.8,13,6,16.3 c0.1,1.2-0.3,2.4-1.1,3.4c-2,2.5-2,6.2,0,8.7C5.6,29.3,6,30.5,6,31.7c-0.2,3.2,2,6.2,5.1,7.1c1.2,0.3,2.2,1.1,2.9,2.1 c1.8,2.7,5.3,3.8,8.3,2.7c1.1-0.4,2.4-0.4,3.5,0c0.8,0.3,1.6,0.4,2.4,0.4c2.3,0,4.5-1.1,5.8-3.1c0.7-1,1.7-1.8,2.9-2.1 c3.1-0.8,5.3-3.8,5.1-7.1c-0.1-1.2,0.3-2.4,1.1-3.4C45.2,25.8,45.2,22.2,43.1,19.6z M41.6,27.1c-1.1,1.3-1.6,3-1.5,4.7 c0.1,2.3-1.4,4.4-3.7,5c-1.6,0.4-3.1,1.5-4,2.9c-1.3,1.9-3.7,2.7-5.9,1.9c-0.8-0.3-1.6-0.5-2.5-0.5c-0.8,0-1.7,0.2-2.5,0.5 c-2.2,0.8-4.6,0-5.9-1.9c-0.9-1.4-2.4-2.5-4-2.9c-2.2-0.6-3.8-2.7-3.7-5c0.1-1.7-0.5-3.4-1.5-4.7c-1.5-1.8-1.5-4.4,0-6.2 c1.1-1.3,1.6-3,1.5-4.7c-0.1-2.3,1.4-4.4,3.7-5c1.6-0.4,3.1-1.5,4-2.9c1.3-1.9,3.7-2.7,5.9-1.9c1.6,0.6,3.4,0.6,5,0 c2.2-0.8,4.6,0,5.9,1.9c0.9,1.4,2.4,2.5,4,2.9c2.2,0.6,3.8,2.7,3.7,5c-0.1,1.7,0.5,3.4,1.5,4.7C43,22.7,43,25.3,41.6,27.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,9C15.7,9,9,15.7,9,24s6.7,15,15,15s15-6.7,15-15S32.3,9,24,9z M24,37c-7.2,0-13-5.8-13-13s5.8-13,13-13 s13,5.8,13,13S31.2,37,24,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,19.9l-5.4-0.8L25,14.2h-2l-2.4,4.9l-5.4,0.8l-0.6,1.9l3.9,3.8L17.5,31l1.6,1.2l4.8-2.5l4.8,2.5l1.6-1.2 l-0.9-5.4l3.9-3.8L32.8,19.9z M27.7,24.6l-0.3,0.8l0.7,4.2l-3.7-2h-0.9l-3.7,2l0.7-4.2l-0.3-0.8l-3-2.9l4.2-0.6l0.7-0.5l1.9-3.8 l1.9,3.8l0.7,0.5l4.2,0.6L27.7,24.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,8L6,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/Industry.2455b71c97ff841df1bde5ed797460b8.svg";
export { ForwardRef as ReactComponent };